const openChatPopUp = () => window.YellowMessengerPlugin?.openBot();
const closeChatPopUp = () => window.YellowMessengerPlugin?.closeBot();
const toggleChatPopUp = () => window.YellowMessengerPlugin?.toggleChat();
const show = () => window.YellowMessengerPlugin?.show();
const hide = () => window.YellowMessengerPlugin?.hide();

export const useYellowMessenger = () => {
  return {
    openChatPopUp,
    closeChatPopUp,
    toggleChatPopUp,
    show,
    hide,
  };
};
